import React from 'react';
import { action, makeObservable, observable } from 'mobx';
import authenticateService from '@/apis/authenticate.service';
import { LoginRequestDto } from '@/dto/users/LoginRequest.dto';
import { removeFromStorage, saveToStorage } from '@utils/storage.util';
import { ResetPassword } from '@/dto/users/ResetPassword.dto';
import { ChangeEmail } from '@/dto/users/ChangeEmail.dto';
import { ChangePassword } from '@/dto/users/ChangePassword.dto';

class AuthenticationStore {
  loggedUser: any;
  loginFormValue: LoginRequestDto;

  constructor() {
    this.loggedUser = null;
    this.loginFormValue = {
      email: '',
      password: '',
    };
    makeObservable(this, {
      loggedUser: observable,
      loginFormValue: observable,
      login: action,
      logout: action,
      verifyEmail: action,
      verifyChangeEmail: action,
      confirmChangeEmail: action,
      forgotPassword: action,
      resetPassword: action,
      changeEmail: action,
      saveUser: action,
    });
  }

  // private function

  private _setCurrentInfo(data: any) {
    this.loggedUser = data;
    saveToStorage('token', data.token);
  }

  private _redirectAfterLogin(history: any) {
    if (this.loggedUser) {
      return history.push('/users');
    }
    return history.push('/');
  }

  // action

  saveUser(data: any) {
    this.loggedUser = data;
  }

  // @action
  async login(history: any) {
    const data = await authenticateService.login(this.loginFormValue);
    await this._setCurrentInfo(data);
    this._redirectAfterLogin(history);
  }

  // @action
  async validateToken(token: string) {
    const data = await authenticateService.validateToken(token);
    if (data) {
      this.saveUser(data);
    }
  }

  // @action
  async verifyEmail(token: string) {
    return await authenticateService.verifyEmail(token);
  }

  // @action
  async verifyChangeEmail(token: string) {
    return await authenticateService.verifyChangeEmail(token);
  }

  // @action
  async confirmChangeEmail(token: string) {
    return await authenticateService.confirmChangeEmail(token);
  }

  // @action
  async forgotPassword(email: string) {
    return await authenticateService.forgotPassword(email);
  }

  // @action
  async resetPassword(model: ResetPassword) {
    return await authenticateService.resetPassword(model);
  }

  async changePassword(model: ChangePassword) {
    return await authenticateService.changePassword(model);
  }

  // @action
  async changeEmail(model: ChangeEmail) {
    return await authenticateService.changeEmail(model);
  }

  // @action
  logout(history: any) {
    removeFromStorage('token');
    this.loggedUser = null;
    return history.push('/');
  }
}

export const AuthenticationStoreContext = React.createContext(
  new AuthenticationStore()
);
